module.exports = __webpack_public_path__ + "static/media/Snow.a6a06fe6.svg";